module.exports = __webpack_public_path__ + "collect-no-padding-9b5edd74534e8dec4946445a4f022ae9.webp";